import styled from "styled-components";
import { sizes } from "styles";

export const RateClassCardContainer = styled.div`
  width: ${sizes.kelasLive.rateClassCardWidth};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white};
  padding: 20px;
  cursor: pointer;
  box-shadow: 0px 0px 14px ${({ theme }) => theme.colors.transparent.white10};
`;

export const RateClassCardHeader = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  color: ${({ theme }) => theme.colors.neutral[1000]};
  text-align: center;
  line-height: 28px;
`;
